import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { map, takeUntil } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { utiles } from '@utl/environment';
import { CommonService } from './common.service';
import { Observable } from 'rxjs';
import { GlassInfo } from '@core/model/glassInfo.model';
import { ModelConfigInfo } from '@core/model/modelConfigInfo.model';
import { PVBConfigInfo } from '@core/model/PvbConfigInfo.model';
import { VilaxInfo } from '@core/model/vilaxInfo.model';
import { DvhInfo } from '@core/model/dvhInfo.model';
import { Injectable } from "@angular/core";
import { ModelInfo } from '@core/model/modelInfo.model';
import { PrefaReglasInfo } from '@core/model/prefaReglasinfo.model';
import { PrefaSinReglasInfo } from '@core/model/PrefaSinReglasInfo.mode';

const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

@Injectable()
export class ModelsService {
  unsubscribe$: Observable<any>;

  constructor(public http: HttpClient, private router: Router, private common: CommonService) {
    let data = utiles.getCacheUser();
    if (data !== null && data !== undefined) {
    } else {
      this.common._setLoading(false);
      this.router.navigate(['login']);
    }
  }

  getGlassTypes(loadeffect: boolean = false) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetGlassTypes';
    return this.http.post<any[]>(url, null, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getGlassThickness(model: any, loadeffect: boolean = false) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetGlassThickness';
    return this.http.post<any[]>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getGlassStyles(model: any, loadeffect: boolean = false) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetGlassStyles';
    return this.http.post<any[]>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getGlassCombination(model: any, loadeffect: boolean = false) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetGlassCombination';
    return this.http.post<any[]>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getGlassServices(model: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetGlassServices';
    return this.http.post<any[]>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getModelServices(modelName: string) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetModelServices';
    return this.http.post<any[]>(url, JSON.stringify(modelName), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getCutServices(thicknesRefRecId: bigint) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetCutServices';
    return this.http.post<any[]>(url, thicknesRefRecId, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getGlassFilteredData(model: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetGlassStyles';
    return this.http.post<any[]>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getCalcProdVC(model: GlassInfo) {
    this.common._setLoading(true);
    const url = environment.apiModelsURL + 'CalcProdVC';
    return this.http.post<GlassInfo>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getCalcProdVilax(model: VilaxInfo) {
    this.common._setLoading(true);
    const url = environment.apiModelsURL + 'CalcProdVilax';
    return this.http.post<VilaxInfo>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getCalcProdDVH(model: DvhInfo) {
    this.common._setLoading(true);
    const url = environment.apiModelsURL + 'CalcProdDVH';
    return this.http.post<DvhInfo>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getCalcProdPrefaReglas(model: PrefaReglasInfo) {
    this.common._setLoading(true);
    const url = environment.apiModelsURL + 'CalcProdPrefaReglas';
    return this.http.post<PrefaReglasInfo>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }
  getCalcProdPrefaSinReglas(model: PrefaSinReglasInfo) {
    this.common._setLoading(true);
    const url = environment.apiModelsURL + 'CalcProdPrefaReglas';
    return this.http.post<PrefaSinReglasInfo>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getProdServiceParams() {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetProdServParams';
    return this.http.post<any[]>(url, null, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getVCImage(model: GlassInfo) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetVCImage';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getPrefaImage(model: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetPrefaImage';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  validateServices(model: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'validateServices';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  async getModelInformation(shoppingCartItemId: number) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'getModelInformation';
    let result = await this.http.post<ModelInfo>(url, shoppingCartItemId, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      })).toPromise();
      
    return result;
  }

  getModelConfigInfo(ItemId: string) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetModelConfigInfo';
    return this.http.post<ModelConfigInfo>(url, JSON.stringify(ItemId), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  GetInfoInterCapas(Model: string) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetInfoInterCapas';
    return this.http.post<PVBConfigInfo>(url, JSON.stringify(Model), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  recalcDimLuces(model: PrefaReglasInfo) {
    this.common._setLoading(true);
    const url = environment.apiModelsURL + 'recalcDimLuces';
    return this.http.post<PrefaReglasInfo[]>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return JSON.stringify(response);
      }));
  }
  recalcDimLucesSinReglas(model: PrefaSinReglasInfo) {
    this.common._setLoading(true);
    const url = environment.apiModelsURL + 'recalcDimLuces';
    return this.http.post<PrefaSinReglasInfo[]>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return JSON.stringify(response);
      }));
  }

  CalcCerradurasAdic(model: PrefaReglasInfo) {
    this.common._setLoading(true);
    const url = environment.apiModelsURL + 'calcCerradurasAdic';
    return this.http.post<PrefaReglasInfo[]>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return JSON.stringify(response);
      }));
  }
  CalcCerradurasAdicSinReglas(model: PrefaSinReglasInfo) {
    this.common._setLoading(true);
    const url = environment.apiModelsURL + 'calcCerradurasAdic';
    return this.http.post<PrefaSinReglasInfo[]>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return JSON.stringify(response);
      }));
  }
}
